import produce from 'immer';
import {State, Actions} from './interfaces';
import {
  GET_FLEETS,
  GET_FLEETS_SUCCESS,
  GET_FLEETS_FAILED,
  GET_CENTERS_FAILED,
  GET_CENTERS,
  GET_CENTERS_SUCCESS,
  GET_VEHICLE_PREFERRED_SOURCES_FAILED,
  GET_VEHICLE_PREFERRED_SOURCES_SUCCESS,
  GET_VEHICLE_PREFERRED_SOURCES,
  GET_FLEET_SHIFTS,
  GET_FLEET_SHIFTS_SUCCESS,
  GET_FLEET_SHIFTS_FAILED,
  GET_FLEET,
  GET_FLEET_SUCCESS,
  GET_FLEET_FAILED,
} from './constants';

export const initialState: State = {
  fleetsList: [],
  fleet: {},
  centersList: [],
  preferredSourcesLoading: false,
  preferredSources: [],
  fleetShifts: {},
  fleetShiftsLoading: false,
  count: 0,
  loading: false,
  error: '',
};

export const FleetsReducer = (state = initialState, action: Actions) =>
  produce(state, draft => {
    switch (action.type) {
      case GET_FLEETS:
        draft.loading = true;
        break;
      case GET_FLEETS_SUCCESS:
        draft.fleetsList = action.data;
        draft.count = action.count;
        draft.loading = false;
        break;
      case GET_FLEETS_FAILED:
        draft.error = action.error;
        draft.loading = false;
        break;

      case GET_FLEET:
        draft.loading = true;
        break;
      case GET_FLEET_SUCCESS:
        draft.fleet = action.data;
        draft.loading = false;
        break;
      case GET_FLEET_FAILED:
        draft.error = action.error;
        draft.loading = false;
        break;

      case GET_CENTERS:
        draft.loading = true;
        break;
      case GET_CENTERS_SUCCESS:
        draft.centersList = action.data;
        draft.loading = false;
        break;
      case GET_CENTERS_FAILED:
        draft.error = action.error;
        draft.loading = false;
        break;

      case GET_VEHICLE_PREFERRED_SOURCES:
        draft.preferredSourcesLoading = true;
        break;

      case GET_VEHICLE_PREFERRED_SOURCES_SUCCESS:
        draft.preferredSources = action.data;
        draft.preferredSourcesLoading = false;
        break;
      case GET_VEHICLE_PREFERRED_SOURCES_FAILED:
        draft.error = action.error;
        draft.preferredSourcesLoading = false;
        break;

      case GET_FLEET_SHIFTS:
        draft.fleetShiftsLoading = true;
        break;
      case GET_FLEET_SHIFTS_SUCCESS:
        draft.fleetShifts = action.data;
        draft.fleetShiftsLoading = false;
        break;
      case GET_FLEET_SHIFTS_FAILED:
        draft.error = action.error;
        draft.fleetShiftsLoading = false;
        break;

      default:
        break;
    }
  });
export default FleetsReducer;
